require("core-js/modules/es.object.to-string");

module.exports = function (file) {
  return function () {
    return import('@/' + file);
  };
};